import { useState } from 'react';
import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus('success');
      setFormMessage('提交成功，我们会尽快处理您的投稿！');
      form.reset();
      return;
    }
    try {
      const formData = new FormData(form);
      const params = new URLSearchParams();
      formData.forEach((value, key) => { params.append(key, value as string); });
      const res = await fetch('https://readdy.ai/api/form/d9lgrsgbdkpk99j7g0e0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      if (res.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormMessage('投稿已成功提交，我们的编辑会尽快审核，感谢您的爆料！');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败';
        setFormStatus('error');
        setFormMessage(serverMsg);
      }
    } catch {
      setFormStatus('error');
      setFormMessage('网络错误，请稍后重试');
    }
  };

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              {contactData.title}
            </h2>
            <p className="text-sm text-foreground-500 mb-6 leading-relaxed">{contactData.intro}</p>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-accent-600" />
                </div>
                <div>
                  <p className="text-xs text-foreground-400">投稿邮箱</p>
                  <p className="text-sm font-medium text-foreground-900">{contactData.email}</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-wechat-line text-accent-600" />
                </div>
                <div>
                  <p className="text-xs text-foreground-400">微信</p>
                  <p className="text-sm font-medium text-foreground-900">{contactData.wechat}</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-qq-line text-accent-600" />
                </div>
                <div>
                  <p className="text-xs text-foreground-400">QQ群</p>
                  <p className="text-sm font-medium text-foreground-900">{contactData.qq}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200">
            <form data-readdy-form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">您的昵称</label>
                <input id="contact-name" name="name" type="text" required className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors" placeholder="如何称呼您？" />
              </div>
              <div>
                <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">联系邮箱</label>
                <input id="contact-email" name="email" type="email" required className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors" placeholder="your@email.com" />
              </div>
              <div>
                <label htmlFor="contact-topic" className="block text-sm font-medium text-foreground-700 mb-1.5">爆料主题</label>
                <input id="contact-topic" name="topic" type="text" required className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors" placeholder="简单描述你要爆料的内容" />
              </div>
              <div>
                <label htmlFor="contact-detail" className="block text-sm font-medium text-foreground-700 mb-1.5">详细描述</label>
                <textarea id="contact-detail" name="detail" rows={4} required maxLength={500} className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none" placeholder="请详细描述你知道的情况（最多500字）" />
                <p className="text-xs text-foreground-400 mt-1 text-right">最多500字</p>
              </div>
              <input name="phone_alt" type="text" tabIndex={-1} autoComplete="off" readOnly aria-hidden="true" className="honeypot-field" />
              <button type="submit" className="w-full px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-colors text-sm whitespace-nowrap cursor-pointer">
                <i className="ri-send-plane-line mr-2" />
                提交爆料
              </button>
              {formStatus === 'success' && (
                <p className="text-sm text-accent-600 text-center">{formMessage}</p>
              )}
              {formStatus === 'error' && (
                <p className="text-sm text-primary-600 text-center">{formMessage}</p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}